<template>
  <div class="course-mulu bg-white pb-44">
    <slot></slot>
    <div v-if="!isLoading">
      <van-collapse class="home-course-mulu" v-if="courseMuluList && courseMuluList.length>0"
                    v-model="activeNames">
        <div v-for="(item, index) in courseMuluList" :key="index">
          <van-cell v-if="item.chapterId===''"
                    class="bg-white line-24 w-100 text-left position-relative van-cell--clickable">
            <template #title>
              <div v-if="item.sessionType==='video' || item.sessionType==='doc' ||item.sessionType==='exam'"
                   class="d-flex align-items-center w-100 overflow-hidden">
                <div class="biao mr-10" v-if="type==='chome'">
                  <img v-if="item.state===0" class="w-100" :src="jingduImgs[0]" alt="">
                  <img v-else-if="item.state===2" class="w-100" :src="jingduImgs[2]" alt="">
                  <img v-else-if="item.state===1" class="w-100" :src="jingduImgs[1]" alt="">
                </div>

                <div class="d-flex w-100 align-items-center">
                  <div v-if="item.sessionType==='video'"
                       class="d-flex flex-column justify-content-around align-items-center doc-img position-relative">
                    <img class="doc-icon" src="/static/img/pro/shipin.png" alt="">
                    视频
                  </div>
                  <div v-else-if="item.sessionType==='doc'"
                       class="d-flex flex-column justify-content-around align-items-center doc-img position-relative">
                    <img class="doc-icon" src="/static/img/pro/wendang.png" alt="">
                    文档
                  </div>
                  <div v-else-if="item.sessionType==='exam'"
                       class="d-flex flex-column justify-content-around align-items-center doc-img position-relative">
                    <img class="doc-icon" src="/static/img/pro/kaoshi.png" alt="">
                    考试
                  </div>

                  <div class="d-flex flex-column justify-content-center mb-0" @click="goStudy(item)">
                    <p class="jie-title van-multi-ellipsis--l3 w-90  mb-10 color-0d">{{item.title}}</p>
                    <div class="d-flex align-items-center">
                      <p class="d-flex align-items-center mr-18 mb-0 color-88 font-12 ">
                        <svg v-if="item.mustLearn" t="1599809449348" class="little-icon icon" viewBox="0 0 1024 1024"
                             version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23156" width="16" height="16">
                          <path
                            d="M893.866667 96l-17.066667-6.4c-34.133333-14.933333-81.066667-21.333333-132.266667-21.333333-49.066667 0-96 6.4-132.266666 21.333333L514.133333 128l-100.266666-40.533333c-34.133333-14.933333-81.066667-21.333333-132.266667-21.333334s-96 6.4-132.266667 21.333334l-14.933333 8.533333C85.333333 115.2 42.666667 179.2 42.666667 232.533333v622.933334c0 44.8 27.733333 74.666667 64 74.666666 10.666667 0 21.333333-2.133333 32-6.4l17.066666-6.4c34.133333-14.933333 78.933333-21.333333 125.866667-21.333333s91.733333 6.4 123.733333 19.2l106.666667 42.666667 106.666667-42.666667c32-12.8 76.8-19.2 123.733333-19.2 46.933333 0 91.733333 6.4 123.733333 19.2l17.066667 6.4c12.8 4.266667 21.333333 6.4 32 6.4 40.533333 0 64-29.866667 64-74.666667V232.533333c6.4-57.6-32-117.333333-85.333333-136.533333zM546.133333 738.133333c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32V187.733333h64v550.4z"
                            p-id="23157" fill="#888888"></path>
                        </svg>
                        <svg v-else class="little-icon icon" t="1599808511417" viewBox="0 0 1160 1024" version="1.1"
                             xmlns="http://www.w3.org/2000/svg" p-id="2904" width="16" height="16">
                          <path
                            d="M742.810069 933.394355h357.736079c32.805492 0 59.362319-26.556827 59.362319-59.362318V59.75286C1159.908467 26.947368 1133.35164 0.390542 1100.546148 0.390542H668.997712l-89.043479 89.043478L490.910755 0.390542H59.362319C26.556827 0.390542 0 26.947368 0 59.75286v814.279177c0 32.805492 26.556827 59.362319 59.362319 59.362318h357.736079c34.367658 53.504195 94.51106 89.43402 162.855835 89.43402 68.344775 0 128.488177-35.539283 162.855836-89.43402z m-162.855836 0c-52.332571 0-95.292143-39.054157-102.712433-89.434019H89.043478V89.43402h371.405035L535.432494 164.02746v475.679634c0 24.604119 19.91762 44.521739 44.521739 44.521739 24.604119 0 44.521739-19.91762 44.52174-44.521739V164.02746L699.069413 89.43402h371.405034v754.916857h-388.198322c-7.029748 50.379863-49.989321 89.043478-102.321892 89.043478z m0 0"
                            p-id="2905" fill="#888888"></path>
                        </svg>
                        {{item.mustLearn?'必学':'选学'}}
                      </p>

                      <p class=" mb-0 color-88 font-12" v-if="type==='chome' && item.userSession && item.state!==2">
                        {{item.userSession.updatedTime|dateFormat}}<span
                        class="ml-2">最后学习</span></p>
                      <p class="color-88 font-12 mb-0" v-if="type==='chome' && !item.userSession">未学习</p>
                    </div>

                  </div>
                </div>
              </div>
<!--              <a href="#" class="position-absolute d-block my-ellipsis-icon">-->
<!--                <svg t="1592303377722" class="icon" viewBox="0 0 1024 1024" version="1.1"-->
<!--                     xmlns="http://www.w3.org/2000/svg" p-id="2622" width="16" height="16">-->
<!--                  <path-->
<!--                    d="M592 803c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z m-1e-8-291c0 44.183-35.817 80-79.99999999 79.99999999s-80-35.817-79.99999999-79.99999999 35.817-80 79.99999999-79.99999999 80 35.817 79.99999999 79.99999999z m1e-8-291c0 44.183-35.817 80-80 80s-80-35.817-80-80 35.817-80 80-80 80 35.817 80 80z"-->
<!--                    p-id="2623"></path>-->
<!--                </svg>-->
<!--              </a>-->
            </template>
          </van-cell>
          <van-collapse-item v-else :id="index+1" :name="index">
            <template #title>
              <div class="biao mr-2" v-if="type==='chome'">
                <img class="w-100" :src="jingduImgs[item.state]" alt="">
              </div>
              <p class="mb-0 van-ellipsis w-80 color-0d">
                {{ item.title }}</p>
            </template>
            <p class="zhang-desc">
              {{ item.summary }}
            </p>
            <div class="bg-white">
              <div class="child-list" v-if="item.chlidList && item.chlidList.length>0">
                <van-cell class=" line-24 w-100 text-left position-relative"
                          v-for="v in item.chlidList" :key="v.id">
                  <template #title>
                    <div v-if="v.sessionType==='video' || v.sessionType==='doc' || v.sessionType==='exam'"
                         class="d-flex align-items-center w-100 overflow-hidden">
                      <div class="little-biao mr-10" v-if="type==='chome'">
                        <img v-if="!v.userSession" class="w-100" :src="jingduImgs[0]" alt="">
                        <img v-else-if="v.userSession && v.userSession.progress===100" class="w-100"
                             :src="jingduImgs[3]" alt="">
                        <img v-else-if="v.userSession && v.userSession.progress && v.userSession.progress!==100"
                             class="w-100" :src="jingduImgs[1]" alt="">
                      </div>

                      <div class="d-flex w-100 align-items-center">
                        <div v-if="v.sessionType==='video'"
                             class="d-flex flex-column justify-content-around align-items-center doc-img">
                          <img class="doc-icon" src="/static/img/pro/shipin.png" alt="">
                          视频
                        </div>
                        <div v-else-if="v.sessionType==='exam'"
                             class="d-flex flex-column justify-content-around align-items-center doc-img">
                          <img class="doc-icon" src="/static/img/pro/kaoshi.png" alt="">
                          考试
                        </div>

                        <div v-else-if="v.sessionType==='doc'"
                             class="d-flex flex-column justify-content-around align-items-center doc-img">
                          <img class="doc-icon" src="/static/img/pro/wendang.png" alt="">
                          文档
                        </div>

                        <div class="d-flex flex-column justify-content-center mb-0">
                          <p class="jie-title van-multi-ellipsis--l3 w-90 color-0d mb-10"
                             @click="goStudy(v)">{{v.title}}</p>
                          <div class="d-flex align-items-center">
                            <p class="d-flex align-items-center mr-18 mb-0 color-88 font-12 ">
                              <svg v-if="v.mustLearn" t="1599809449348" class="little-icon icon" viewBox="0 0 1024 1024"
                                   version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="23156" width="16" height="16">
                                <path
                                  d="M893.866667 96l-17.066667-6.4c-34.133333-14.933333-81.066667-21.333333-132.266667-21.333333-49.066667 0-96 6.4-132.266666 21.333333L514.133333 128l-100.266666-40.533333c-34.133333-14.933333-81.066667-21.333333-132.266667-21.333334s-96 6.4-132.266667 21.333334l-14.933333 8.533333C85.333333 115.2 42.666667 179.2 42.666667 232.533333v622.933334c0 44.8 27.733333 74.666667 64 74.666666 10.666667 0 21.333333-2.133333 32-6.4l17.066666-6.4c34.133333-14.933333 78.933333-21.333333 125.866667-21.333333s91.733333 6.4 123.733333 19.2l106.666667 42.666667 106.666667-42.666667c32-12.8 76.8-19.2 123.733333-19.2 46.933333 0 91.733333 6.4 123.733333 19.2l17.066667 6.4c12.8 4.266667 21.333333 6.4 32 6.4 40.533333 0 64-29.866667 64-74.666667V232.533333c6.4-57.6-32-117.333333-85.333333-136.533333zM546.133333 738.133333c0 17.066667-14.933333 32-32 32s-32-14.933333-32-32V187.733333h64v550.4z"
                                  p-id="23157" fill="#888888"></path>
                              </svg>
                              <svg v-else class="little-icon icon" t="1599808511417" viewBox="0 0 1160 1024" version="1.1"
                                   xmlns="http://www.w3.org/2000/svg" p-id="2904" width="16" height="16">
                                <path
                                  d="M742.810069 933.394355h357.736079c32.805492 0 59.362319-26.556827 59.362319-59.362318V59.75286C1159.908467 26.947368 1133.35164 0.390542 1100.546148 0.390542H668.997712l-89.043479 89.043478L490.910755 0.390542H59.362319C26.556827 0.390542 0 26.947368 0 59.75286v814.279177c0 32.805492 26.556827 59.362319 59.362319 59.362318h357.736079c34.367658 53.504195 94.51106 89.43402 162.855835 89.43402 68.344775 0 128.488177-35.539283 162.855836-89.43402z m-162.855836 0c-52.332571 0-95.292143-39.054157-102.712433-89.434019H89.043478V89.43402h371.405035L535.432494 164.02746v475.679634c0 24.604119 19.91762 44.521739 44.521739 44.521739 24.604119 0 44.521739-19.91762 44.52174-44.521739V164.02746L699.069413 89.43402h371.405034v754.916857h-388.198322c-7.029748 50.379863-49.989321 89.043478-102.321892 89.043478z m0 0"
                                  p-id="2905" fill="#888888"></path>
                              </svg>
                              {{v.mustLearn?'必学':'选学'}}
                            </p>
                            <p class=" mb-0 color-88 font-12" v-if="type==='chome' && v.userSession && v.state!==2">
                              {{v.userSession.updatedTime|dateFormat}}
                              <span class="ml-2">最后学习</span>
                            </p>
                            <p class="color-88 font-12 mb-0" v-if="type==='chome' && !v.userSession">未学习</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </van-cell>
              </div>

            </div>
          </van-collapse-item>
        </div>
      </van-collapse>
      <no-data v-else text="暂无小节内容"></no-data>
    </div>
    <van-loading class="my-5" v-else size="24px" vertical>加载中...</van-loading>
  </div>
</template>

<script>
  import noData from '@/components/noData';
  import Vue from 'vue';
  import {Icon, Loading} from 'vant';
  import {List} from 'vant';
  import {Cell, CellGroup} from 'vant';
  import {Collapse, CollapseItem} from 'vant';
  import {Circle} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Circle);
  Vue.use(Collapse);
  Vue.use(CollapseItem);
  Vue.use(Cell);
  Vue.use(CellGroup);
  Vue.use(List);
  Vue.use(Icon);
  Vue.use(Loading);
  export default {
    name: "courseMuluComponent",
    data() {
      return {
        list: [],
        activeNames: [0],
        currentRate: 0,
        currentRate2: 0,
        defaultImg: '/static/img/pro/kczy-banner.png',
        defaultImage: '/static/img/pro/kczy-banner.png',
        finishedNum: 0,
        courseMuluList: [],
        arrList: [],
        currentCourse: {},
        courseMuluObj: {},
        sessionMapObj: {},
        topList: [],
        fromType: '',
        isLoading: true
      };
    },
    components: {
      noData
    },
    props: [
      'type',
      'curCourse'
    ],
    created() {
      this.fromType = this.type;
      if(this.fromType === 'adv') {
        this.currentCourse = this.curCourse;
        this.getMuluList();
      }
    },
    mounted() {
      this.courseId = this.$route.params['id'];
    },
    computed: {
      ...mapState({
        jingduImgs: state => state.jingduImgs
      })
    },
    watch: {
      curCourse: function (newVal, oldVal) {
        if(newVal) {
          this.currentCourse = newVal;
          this.getMuluList();
        }
      }
    },
    methods: {
      goStudy(item) {
        if (this.fromType === 'chome') {
          this.$router.push('/course/' + item.sessionType + '/' + item.id);
        } else {
          return false;
        }
      },
      getMuluList() {
        this.isLoading = true;
        this.courseMuluObj = {};
        this.courseMuluObj.chapterList = this.currentCourse.chapterList ? this.currentCourse.chapterList : [];
        this.courseMuluObj.sessionList = this.currentCourse.sessionList ? this.currentCourse.sessionList : [];
        this.sortMulu();
      },
      sortMulu() {
        this.getSessionMap();
        if (this.courseMuluObj.sessionList && this.courseMuluObj.sessionList.length > 0) {
          for (let m of this.courseMuluObj.sessionList) {
            if (m.userSession && m.userSession.progress !== 100) {
              m.state = 1;
            } else if (m.userSession && m.userSession.progress === 100) {
              m.state = 2;
            } else {
              m.state = 0;
            }
            if (m.chapterId === '') {
              //top=true的，扔到一个数组中，最后排序完合并到大数组中
              if (m.top) {
                this.topList.push(m)
              } else {
                this.courseMuluList.push(m);
              }
            } else {
              if (this.sessionMapObj[m.chapterId]) {
                if (m.state === 2) {
                  this.sessionMapObj[m.chapterId].finishedNum += 1;
                }
                this.sessionMapObj[m.chapterId].chlidList.push(m);
              } else {
                //有章节ID，存在找不到的情况吗？
              }
            }
          }

          for (let i in this.sessionMapObj) {
            //处理章节的显示状态
            if (this.sessionMapObj[i].chlidList && this.sessionMapObj[i].chlidList.length > 0) {
              this.sessionMapObj[i].chlidList.sort(this.compare('sort'));
              if (this.sessionMapObj[i].finishedNum > 0) {
                if (this.sessionMapObj[i].chlidList.length === this.sessionMapObj[i].finishedNum) {
                  this.sessionMapObj[i].state = 2;
                } else {
                  this.sessionMapObj[i].state = 1;
                }
              } else {
                this.sessionMapObj[i].state = 0;
              }
            } else {
              this.sessionMapObj[i].state = 2; //没有小节的章节设为2--完成状态
            }
            // this.sessionMapObj[i].state = this.sessionMapObj[i].state ? this.sessionMapObj[i].state : 0;
            this.courseMuluList.push(this.sessionMapObj[i]);
          }

        }


        if (this.topList && this.topList.length > 0) {

          this.topList.sort(this.compare('sort'));
        }
        if (this.courseMuluList && this.courseMuluList.length > 0) {
          this.courseMuluList.sort(this.compare('sort'));
          this.courseMuluList = this.topList.concat(this.courseMuluList);
          if (this.courseMuluList[0] && !this.courseMuluList[0].hasOwnProperty('chapterId')) {
            // alert('需要将第一个章节展开')
          }
        } else if(this.topList && this.topList.length > 0) {
          this.courseMuluList = this.topList.concat(this.courseMuluList);
        }else {
          this.courseMuluList = [];
        }
        this.isLoading = false;
      },
      getSessionMap() {
        this.topList = [];
        if (this.courseMuluObj.chapterList && this.courseMuluObj.chapterList.length > 0) {
          for (let v of this.courseMuluObj.chapterList) {
            v.chlidList = v.chlidList ? v.chlidList : [];
            v.finishedNum = v.finishedNum ? v.finishedNum : 0;
            this.sessionMapObj[v.id] = v;
          }

        }
      },
      compare(property) {
        return function (a, b) {
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        }

      },
    }
  }
</script>

<style>
  .home-course-mulu:after {
    border: none !important;
  }

  .home-course-mulu .van-collapse-item__content {
    padding: 0;
    color: #888888;
    font-size: .875rem;
  }

  .home-course-mulu .van-cell--clickable {
    /*background: #eeeeee;*/
    padding: 1.25rem 1rem;
    line-height: .9375rem;
  }

  .home-course-mulu .van-cell--clickable > .van-icon {
    margin-left: .3125rem;
    position: absolute;
    top: 1.25rem;
    right: 1rem;
  }

  .doc-img {
    flex: 0 0 4rem;
    height: 2.875rem;
    overflow: hidden;
    margin-right: .75rem;
    color: #888888;
    font-size: .75rem;
    line-height: .75rem;
  }

  .doc-icon {
    height: 1.75rem;
    width: 1.75rem;
    border-radius: .25rem;
    color: white;
    margin-bottom: .375rem;
  }

  .zhang-desc {
    margin-bottom: 0;
    padding: 0 1rem 1.25rem 2.5rem;
    font-size: .75rem;
    color: #888888;
    text-align: justify;
    /*display: -webkit-box;*/
    /*-webkit-box-orient: vertical;*/
    /*-webkit-line-clamp: 4;*/
    /*overflow: hidden;*/
  }

  .zhang-title {
    font-size: 0.875rem;
    height: 2rem;
    padding: 0 1rem;
  }

  .zhang-title .biao {
    width: 0.875rem;
  }

  .parent-cell {
    padding: .625rem 0;
    background-color: #F2F2F2;
  }

  .child-list {
    padding: 1.5rem .5rem 0 2.5rem;
  }

  .child-list .van-cell {
    padding: 0 0 1.5rem;
  }

  .child-list .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  .home-course-mulu .van-cell:not(:last-child)::after {
    border-bottom: none;
  }

  .parent-cell > .van-cell__title {
    background-color: #f8f9fa;
    padding: 0 .875rem;
  }

  .van-cell .van-cell__title {
    display: flex;
    align-items: center;
    position: relative;
    font-size: .8125rem;
    color: #0d0d0d;
    width: 100%;
  }

  .van-cell .biao {
    display: flex;
    align-items: center;
    flex: 0 0 .875rem;
  }

  .little-biao {
    flex: none;
    width: .5rem;
    border-radius: 50%;
  }

  .grey-round {
    background-color: #ccc;
  }

  .blue-round {
    background-color: #2474FF;
  }

  .jie-title {
    font-size: .8125rem;
    color: #0d0d0d;
    line-height: 1.25rem;
    position: relative;
    top: -.125rem;
  }

  .jie-date {
    font-size: .75rem;
    color: #888888;
    line-height: .75rem;
    margin-top: .75rem;
  }

  .duration-block {
    bottom: 0;
    right: 0;
    background-color: #26262645;
    line-height: 1.25rem;
    padding: 0 .25rem;
    border-radius: .25rem;
  }
  .bg-f2 {
    background-color: #f2f2f2
  }
</style>
